import Utils from "../../services/Utils.js";
import { updatePrivilege, getChildrenPrivileges } from "../../js/api/privileges.js";
import { userData } from "../../js/api/profile.js"
  
let UserPrivileges = {
    render: async () => {
        const role = localStorage.getItem("role");
        if(['CompanyAdmin', 'SuperAdmin'].indexOf(role) === -1) {
            location.href = '/#/';
            return;
        }
        let request = Utils.parseRequestURL();
        const user = await userData(request.id);
        let userPrivileges = await getChildrenPrivileges(request.id);
        console.log(userPrivileges);

        let privilegesView = ``;
        $.each(userPrivileges, function(i,item){
            privilegesView += `
                <div class="privilegesRow" privilege-id="${item.id}">
                    <span class="privilegeName" href="">${item.name}</span>
                    <div class="switchItem ${item.status !== '0' ? 'switched' : ''}">
                        <div class="switchBall"></div>
                    </div>
                </div>
            `
        });

        let view = /*html*/ `  
                <div class="createUsersHeader m-t-6">
                    <a class="backBtn">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                    </a>
                    <span><b>${user.name}</b> privileges</span>
                </div>
                <div class="messageShow">
                    <span>You have successfully update configuration!</span>
                </div>
                <div class="privilegesHolder">
                    <div class="privilegesPosition">
                        ${privilegesView}
                    </div>
                </div>
            `;
        return view;
    },
    after_render: async () => {

        let request = Utils.parseRequestURL();

        $('body').on('click', '.switchItem', async function(e){
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            let privilegeId = $(e.currentTarget).parent().attr('privilege-id');
            if($(e.currentTarget).hasClass('switched')){
              $(e.currentTarget).removeClass('switched');
              let updatePrivilegeResponse = await updatePrivilege(request.id,0,privilegeId);
              console.log(updatePrivilegeResponse, 'i hjeka')
            }else {
              $(e.currentTarget).addClass('switched');
              let updatePrivilegeResponse = await updatePrivilege(request.id,1,privilegeId);
              console.log(updatePrivilegeResponse, 'i qita')
            }

            $('body .messageShow').addClass('showMessage');
            setTimeout(function(){
                $(e.currentTarget).closest('.accordionWrapper').removeClass('clicked');
                $('body .messageShow').removeClass('showMessage');
            }, 2000);
          });
        
    },
};

export default UserPrivileges;
  